import { render, staticRenderFns } from "./KETWidgetAnmerkungen.vue?vue&type=template&id=74735932&"
import script from "./KETWidgetAnmerkungen.vue?vue&type=script&lang=js&"
export * from "./KETWidgetAnmerkungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports